import { NAVBAR_PROFILE_BUTTON_CLASS_NAME, DEFAULT_ICON_BUTTON_CLASS_NAME } from '../../constants/icon-button';
import FingoMuiIconButton from '../../fingo/components/MuiIconButton';

const navbarProfileButton = ({ theme }) => ({
  backgroundColor: theme.palette.gray.A300,
  '&:hover': {
    backgroundColor: theme.palette.gray.A300,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
});

const defaultIconButton = ({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.secondary.A500,
  },
});

const MuiIconButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiIconButton.styleOverrides.root({ theme }),
      [`&.${NAVBAR_PROFILE_BUTTON_CLASS_NAME}`]: navbarProfileButton({ theme }),
      [`&.${DEFAULT_ICON_BUTTON_CLASS_NAME}`]: defaultIconButton({ theme }),
    }),
  },
};

export default MuiIconButton;
